export { CovidCircleIcon } from './covid-circle'
